export const state = () => ({
  featureFlagCumulativeDiscountPixLoaded: false
})

export const mutations = {
  SET_FEATURE_FLAG_CUMULATIVE_DISCOUNT_PIX_LOADED(state, value) {
    state.featureFlagCumulativeDiscountPixLoaded = value
  }
}

export const actions = {
  setFeatureFlagCumulativeDiscountPixLoaded({ commit }, value) {
    commit('SET_FEATURE_FLAG_CUMULATIVE_DISCOUNT_PIX_LOADED', value)
  }
}

export const getters = {
  GET_FEATURE_FLAG_CUMULATIVE_DISCOUNT_PIX_LOADED: state => state.featureFlagCumulativeDiscountPixLoaded
}
